import { useExperimentStore, useRoutingStore, useUserStore } from '@/helpers/composables/useStores';
import { injectLocal, provideLocal, useMounted } from '@vueuse/core';
import { computed } from 'vue';
import TitlePageLoggedInExp, { TitlePageLoggedInExpName, TitlePageLoggedInExpVariants } from '..';
import { ExperimentTrackEventOptions } from '../../Core/types';

export type TrackTitlePageExp = ReturnType<typeof useTitlePageLoggedInExp>['trackTitlePageExp'];
const acceptedRoutes = ['app.detail.show', 'app.detail.show.season'];
const titlePageExpSymbol = Symbol('TITLE_DETAIL_LOGGED_IN_EXP');
export function useTitlePageLoggedInExp(activeExpCondition?: boolean) {
	const { activeVariantsWithControlGroup } = useExperimentStore();
	const { activeRoute } = useRoutingStore();
	const { isLoggedIn } = useUserStore();
	const isMounted = useMounted();

	if (activeExpCondition) {
		provideLocal(titlePageExpSymbol, activeExpCondition);
	}

	const isExpActiveInject = injectLocal<boolean>(titlePageExpSymbol, false);

	const titlePageActiveVariant = computed(() => {
		if (
			!isExpActiveInject ||
			!isLoggedIn.value ||
			!isMounted.value ||
			!acceptedRoutes.includes(activeRoute.value.name)
		) {
			return undefined;
		}

		return activeVariantsWithControlGroup.value[TitlePageLoggedInExpName] as TitlePageLoggedInExpVariants;
	});

	function trackTitlePageExp(TrackingOptions: ExperimentTrackEventOptions<TitlePageLoggedInExpVariants>) {
		if (titlePageActiveVariant.value) {
			TitlePageLoggedInExp.trackEvent({
				property: 'show_page_logged_in',
				...TrackingOptions,
			});
		}
	}

	return {
		titlePageActiveVariant,
		trackTitlePageExp,
	};
}
